import { styled } from '@styles'

export const Container = styled.div`
  display: flex;
  box-sizing: border-box;
  align-items: center;
  padding-left: 1rem;
  padding-bottom: 1rem;
`
